import { IS_DEV, SENTRY_DSN } from '@/constants/constants';
import * as Sentry from '@sentry/react';

export function initSentry() {
  if (IS_DEV) return;

  Sentry.init({
    dsn: SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
      Sentry.thirdPartyErrorFilterIntegration({
        filterKeys: ['getsign-app'],
        behaviour: 'drop-error-if-contains-third-party-frames',
      }),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0.1,
    ignoreErrors: [
      'NetworkError when attempting to fetch resource',
      'Failed to fetch',
      'Load failed',
      'ResizeObserver loop',
      'Non-Error promise rejection captured',
      'NS_ERROR_FAILURE',
      "null is not an object (evaluating 'zo.sequence')",
    ],
    denyUrls: [/unpkg\.com/i, /cdnjs\.cloudflare\.com/i],
    beforeSend(event) {
      const errorMessage = event?.exception?.values?.[0]?.value || '';
      if (
        errorMessage.includes('NetworkError') &&
        event?.request?.url?.startsWith('blob:')
      ) {
        return null;
      }
      const frames =
        event?.exception?.values?.[0]?.stacktrace?.frames || [];
      if (frames.some((f) => f.filename?.includes('clarity'))) {
        return null;
      }
      return event;
    },
  });
}
